import { createSlice } from '@reduxjs/toolkit';

const groupCodeSlice = createSlice({
  name: 'groupCode',
  initialState: {
    list: [],
  },
  reducers: {
    setGroupCode: (state, action) => {
      state.list = action.payload;
    },
    addGroupCode: (state, action) => {
      state.list.push(action.payload);
    },
    updateGroupCode: (state, action) => {
      const index = state.list.findIndex(product => product._id === action.payload._id);
      if (index !== -1) {
        state.list[index] = action.payload;
      }
    },
 
        deleteGroupCode: (state, action) => {
        state.list = state.list.filter(product => product._id !== action.payload);
        }

  },
});

export const {
  setGroupCode,
  addGroupCode,
  updateGroupCode,
  deleteGroupCode
} = groupCodeSlice.actions;

export default groupCodeSlice.reducer;
